import React, { Component } from "react"

export default class Weltformat extends Component {
  render() {
  return (
      <div className="portfoliosmalldetwrap">
        <div className="portdescwrap">
          <div className="portdesc">
            <p className="portdesctitle">Weltformat</p>
            <p className="portdesctext">Poster submissions for Weltformat festival titled "Not (Yet) Cancelled". Tasked with visually communicating how creatives have been affected by the COVID-19 pandemic conditions. Indepth abstract in link.</p>
          </div>
        </div>
        <div className="portlinkwrap">
          <a href = 'https://www.dropbox.com/s/fl71lho87nz0c2u/weltformat2020.pdf?dl=0' target = "_blank" rel="noopener noreferrer"><p className="linktext">PDF</p></a>
        </div>
      </div>
  )
}
}

